// Fallback JobOffer Box

import './index.scss';

export default class FallbackJobofferBox {
  constructor(root) {
    this.root = root;
  }

  initButton() {
    const button = this.root.querySelector('[data-popup-open="app-form-popup"]');
    if (button) {
      button.addEventListener('click', this.trackFormOpen.bind(this));
    }
  }

  trackPageOpen() {
    this.initButton();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'Joboffer opened',
      'title': this.root.dataset.jobofferName,
      'location': this.root.dataset.jobofferLocation,
      'function': this.root.dataset.jobofferActivity,
    });

    console.log(window.dataLayer);
  }

  trackFormOpen() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'Application form opened',
      'title': this.root.dataset.jobofferName,
      'location': this.root.dataset.jobofferLocation,
      'function': this.root.dataset.jobofferActivity,
    });

    console.log(window.dataLayer);
  }

  trackFormSend() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'Application sent',
      'title': this.root.dataset.jobofferName,
      'location': this.root.dataset.jobofferLocation,
      'function': this.root.dataset.jobofferActivity,
    });

    console.log(window.dataLayer);
  }
}
